<app-settings-sub-header
    [headerData]="subHeaderData"
    [generalTabIndex]="generalTabIndex"
    (languageOutput)="languageOutputHandler($event)"
></app-settings-sub-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch" style="min-height: 100vh">
                <div class="card-body">
                    <mat-tab-group (selectedTabChange)="tabChanged($event)" class="tab-wrapper">
                        <mat-tab
                            label="{{ 'SETTING_PAGE.GENRAL_SETTINGS.TAB_LABEL.HERO_IMAGES' | transloco }}"
                            [aria-label]="0"
                            *ngIf="hideTabHeroImages === true"
                        >
                            <app-shared-content-list
                                [generalTabIndex]="generalTabIndex"
                                [sharedContentType]="'HeroImages'"
                                [language]="language"
                            ></app-shared-content-list>
                        </mat-tab>
                        <mat-tab
                            label="{{ 'SETTING_PAGE.GENRAL_SETTINGS.TAB_LABEL.NEWS_AND_UPDATES' | transloco }}"
                            [aria-label]="1"
                            *ngIf="hideTabNews === true"
                        >
                            <app-shared-content-list
                                [generalTabIndex]="generalTabIndex"
                                [sharedContentType]="'NewsUpdates'"
                                [language]="language"
                            ></app-shared-content-list>
                        </mat-tab>
                        <mat-tab
                            label="{{ 'SETTING_PAGE.GENRAL_SETTINGS.TAB_LABEL.PRICING_DETAILS' | transloco }}"
                            [aria-label]="2"
                            *ngIf="hideTabPricingDetails === true"
                        >
                            <app-shared-content-list
                                [generalTabIndex]="generalTabIndex"
                                [sharedContentType]="'Pricing'"
                                [language]="language"
                            ></app-shared-content-list>
                        </mat-tab>
                        <!-- <mat-tab label="Social Media">
            </mat-tab> -->
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</div>
